import React, { useState, useEffect } from "react";
import { Form } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import storageService from "../services/storage.service";
import moment from 'moment';
import CurrencyInput from 'react-currency-input';
import { ConfigModel, ValueBooleanList } from "../models/config.model";
import { useTranslation } from 'react-i18next';
import _ from 'lodash';
import { UtilService } from "../services/util.service";
import { number } from "yup";
import { ToastService } from "../services/toast.service";

export const FormDynamicControl = (props) => {

  // Exibindo configKey no console
  useEffect(() => {
    //console.log("ConfigKey:", props.configKey);
    //console.log("ConfigValue:", props.configValue);
  }, [props.configKey, props.configValue]);

  const [valorInicio, setValorInicio] = useState(0)
  const [valorFim, setValorFim] = useState(0)

  const [valorFloatInicio, setValorFloatInicio] = useState(0)
  const [valorFloatFim, setValorFloatFim] = useState(0)

  const user = storageService.getUser();
  const formatoData = user.locale.formatDate.replaceAll('DD', 'dd');
  const formatoDataHora = user.locale.formatDateTime.replaceAll('DD', 'dd');

  const isInteger = (props.dataType === "I" ? true : false);
  const isDate = (props.dataType === "D" ? true : false);
  const isText = (props.dataType === "S" ? true : false);

  const isNumber = (props.dataType === "N" ? true : false);

  const isTime = (props.dataType === "T" ? true : false);
  const isBoolean = (props.dataType === "B" ? true : false);
  const isRange = props.isRange;

  const { t } = useTranslation();

  let dtSelecionada = new Date();
  let dtInicio = new Date();
  let dtFim = new Date();
  let _valorInt: number;

  _valorInt = 0;

  if (props.dataType === "D" && props.isRange === true) {
    var splitted = props.value.split("|");
    if (splitted.length === 2) {
      dtInicio = UtilService.configDate(splitted[0]);
      dtFim = UtilService.configDate(splitted[1]);
    }
  }

  
  if (props.dataType === "D" && props.isRange === false && props.configKey != 'last_read_date') {
    var splitted = props.value.split("|");
    if (splitted.length === 2) {
      dtSelecionada = UtilService.configDate(splitted[0]);
    }
    else {
      dtSelecionada = UtilService.configDate(props.value);
    }
  }

  if (props.dataType === "D" && props.isRange === false && props.configKey === 'last_read_date') {
    var splitted = props.value.split("|");

    // Verificar se splitted tem dois elementos válidos
    if (splitted.length === 2 && splitted[0] && splitted[1]) {
      dtSelecionada = UtilService.configDate(splitted[0]);
    } 
    else {     
      // Verifica se splitted tem pelo menos um valor válido
      if (splitted.length > 0 && splitted[0]) {
        dtSelecionada = UtilService.configDate(props.value);
      } 
      else {
        dtSelecionada = null;
      }
    }
  }


  if (props.dataType === "T" && props.isRange === false) {
    dtSelecionada = new Date(props.value);
  }

  if (props.dataType === "I" && props.isRange === false) {
    var splitted = props.value.toString().split("|");
    if (splitted.length === 1) {
      _valorInt = UtilService.onlyNumber(splitted[0])
    }
  }

  const [selectedDate, setSelectedDate] = useState(dtSelecionada || null)
  const [startDate, setStartDate] = useState(dtInicio)
  const [endDate, setEndDate] = useState(dtFim)
  const [valorInt, setValorInt] = useState(_valorInt)

  useEffect(() => {
    if (props.dataType === "I" && props.isRange === true) {
      var splitted = props.value.toString().split("|");
      if (splitted.length === 2) {
        setValorInicio(UtilService.onlyNumber(splitted[0]));
        setValorFim(UtilService.onlyNumber(splitted[1]));
      }
    }

    if (props.dataType === "N" && props.isRange === true) {
      var splitted = props.value.split("|");

      if (splitted.length === 2) {
        let ini: number = splitted[0];
        let fim: number = splitted[1];

        setValorFloatInicio(parseFloat(ini.toString()))
        setValorFloatFim(parseFloat(fim.toString()))
      }
    }

    if (props.dataType === "I" && props.isRange === false) {
      var splitted = props.value.toString().split("|");
      if (splitted.length === 1) {
        let ini: number = splitted[0];
        setValorInt(ini);
      }
    }

  }, [props]);


  // useEffect(() => {   

  //   let valor1 = parseFloat(valorInicio.toString().replaceAll(",", "."));
  //   let valor2 = parseFloat(valorFim.toString().replaceAll(",", "."));

  //   if (valor1 && valor2 && Math.fround(valor1) > Math.fround(valor2)) {
  //     setValorInicio(0)
  //   }

  // }, [valorInicio, valorFim]);

  useEffect(() => {

    /* ##############################  Date INICIO ############################## */

    if (props.dataType === "D" && props.isRange === true) {
      props.handleChangeDateRange(startDate, endDate, props.index, props.data);
    }

    if (props.dataType === "D" && props.isRange === false ) {
      props.handleChangeDate(selectedDate, props.index, props.data);
    }
    /* ##############################  Date FIM ############################## */


    //* ##############################  Number INICIO ############################## */

    if (props.dataType === "N" && props.isRange === true) {
      props.handleChangeMoneyRange(valorFloatInicio, valorFloatFim, props.index, props.data);
    }

    // if (props.dataType === "N" && props.isRange === false) {
    //   console.log('handle-change-money-component');
    //   props.handleChangeMoney(props.value, props.index, props.data);//props.handleChangeMoney(UtilService.onlyNumber(props.value), props.index, props.data);
    // }

    //* ##############################  Number FIM ############################## */


    //* ##############################  Integer INICIO ############################## */

    if (props.dataType === "I" && props.isRange === true) {
      var splitted = props.value.toString().split("|");
      if (splitted.length === 2) {
        props.handleChangeNumberRange(UtilService.onlyNumber(splitted[0]), UtilService.onlyNumber(splitted[1]), props.index, props.data)
      }
    }

    if (props.dataType === "I" && props.isRange === false) {
      let v = UtilService.onlyNumber(valorInt.toString());
      props.handleChangeNumber(v, props.index, props.data)
    }

    //* ##############################  Integer FIM ############################## */

  }, [props.isRange, props.dataType]);


  useEffect(() => {
    if (props.dataType === "D" && props.isRange === true) {
      var splitted = props.value.split("|");
      if (splitted.length === 2) {
        setStartDate(UtilService.configDate(splitted[0]))
        setEndDate(UtilService.configDate(splitted[1]))
      }
    }

    if (props.dataType === "D" && props.isRange === false && props.configKey != 'last_read_date') {
      var splitted = props.value.split("|");
      if (splitted.length === 2) {
        setSelectedDate(UtilService.configDate(splitted[0]))
      }
      else {
        setSelectedDate(UtilService.configDate(props.value))
      }
    }

    if (props.dataType === "D" && props.isRange === false && props.configKey === 'last_read_date') {
      var splitted = props.value.split("|");
      if (splitted.length === 2) {
        setSelectedDate(UtilService.configDate(splitted[0]))
      }
      else {
        // Verifica se splitted tem pelo menos um valor válido
        if (splitted.length > 0 && splitted[0]) {
          dtSelecionada = UtilService.configDate(props.value);
        } 
        else {
          dtSelecionada = null;
        }
      }
    }

  }, [props]);

  const minDate = new Date("2021-01-01T00:00:00");  // Data mínima: 01/01/2021
  const maxDate = new Date(); // Data máxima: hoje
  maxDate.setHours(0, 0, 0, 0); // Garante que a hora seja 00:00:00


  // Função para formatar e validar a data enquanto o usuário digita
  const formatDateInput = (input) => {
    let cleaned = input.replace(/\D/g, ''); // Remove qualquer coisa que não seja número
    console.log("Cleaned: ", cleaned);

    if (cleaned.length > 8) {
      // Limita a entrada a no máximo 8 caracteres (DDMMYYYY)
      cleaned = cleaned.slice(0, 8);
    }

    let match = cleaned.match(/^(\d{2})(\d{2})(\d{4})$/);

    if (match) {
      const day = match[1];
      const month = match[2];
      const year = match[3];

      if (parseInt(year) > 9999 || parseInt(year) < 1000) {
        ToastService.error("Ano inválido. Use um ano entre 1000 e 9999.");
        return `${day}/${month}/`; // Mostra apenas a parte válida até o erro
      }

      return `${day}/${month}/${year}`; // Formata como DD/MM/AAAA
    }

    // Adiciona barras conforme o número de caracteres
    if (cleaned.length >= 2 && cleaned.length <= 4) {
      return `${cleaned.slice(0, 2)}/${cleaned.slice(2)}`;
    } else if (cleaned.length > 4) {
      return `${cleaned.slice(0, 2)}/${cleaned.slice(2, 4)}/${cleaned.slice(4, 8)}`;
    }

    return cleaned; // Retorna a entrada limpa
  };  

  return (
    <>
      {/* ##############################  isText ############################## */}

      {isText && (
        <>
          <Form.Control
            name={props.name}
            id={props.id}
            value={props.value}
            placeholder={props.placeholder}
            disabled={props.disabled}
            type='text'
            onChange={(val) => {
              props.onChange(val)
            }}
          />
          <Form.Label>
            {props.label}
          </Form.Label>
        </>
      )}

      {/* ##############################  isDate ############################## */}

      {(isDate && isRange) && (
        <>
          <DatePicker
            onChange={(date) => {
              const [start, end] = date;
              setStartDate(start);
              setEndDate(end);
              props.handleChangeDateRange(date[0], date[1], props.index, props.data);
            }}
            className={'form-control'}
            selectsRange={true}
            startDate={startDate}
            endDate={endDate}
            dateFormat={formatoData}
            isClearable={true}
          />
        </>
      )}

      {(isDate && !isRange  && props.configKey != 'last_read_date') && (
        <>
          <DatePicker
            onChange={(date) => {
              setSelectedDate(date)
              props.handleChangeDate(date, props.index, props.data);
            }}
            className={'form-control'}
            selected={selectedDate}
            dateFormat={formatoData}
            isClearable={true}
          />
        </>
      )}

      

      {/* Dentro do render do componente isDate e isRange === false*/}
      {(isDate && !isRange && props.configKey == 'last_read_date') && (
        <>
          <DatePicker
            onChange={(date) => {
              // Validação apenas quando a data é selecionada via calendário
              if (date && date < minDate) {
                //ToastService.error("A data não pode ser anterior a 01/01/2021.");
                const correctedDate = new Date(minDate);
                correctedDate.setHours(0, 0, 0, 0); // Garante que seja meia-noite
                setSelectedDate(correctedDate); // Define a data como 01/01/2021
                props.handleChangeDate(correctedDate, props.index, props.data); // Atualiza com a data mínima
              } else if (date && date > maxDate) {
                // Se a data for maior que a data máxima (hoje)
                //ToastService.error("A data não pode ser posterior ao dia de hoje.");
                const correctedDate = new Date(maxDate);
                correctedDate.setHours(0, 0, 0, 0); // Garante que seja meia-noite
                setSelectedDate(correctedDate); // Define a data máxima (hoje)
                props.handleChangeDate(correctedDate, props.index, props.data); // Atualiza com a data máxima
              } else {
                setSelectedDate(date);
                props.handleChangeDate(date, props.index, props.data);
              }
            }}
            onChangeRaw={(e) => {
              // Só processa a formatação quando o usuário digita manualmente
              if (e.target.value) {
                const formattedDate = formatDateInput(e.target.value); // Formata a data enquanto o usuário digita
                e.target.value = formattedDate; // Atualiza o campo com a data formatada
                console.log("Formatted Date (Raw Input): ", formattedDate);
              }
            }}
            className={'form-control'}
            selected={selectedDate}
            dateFormat={formatoData} // Deixe o DatePicker lidar com a formatação ao selecionar
            isClearable={true}
          />
        </>
      )}

      {/* ##############################  isTime    ############################## */}

      {isTime && (
        <>         
          <DatePicker 
            onChange={(date) => {
              setSelectedDate(date)
              props.handleChangeDateTime(date, props.index, props.data);
            }}
            className={'form-control'}
            selected={moment(selectedDate).isValid() ? selectedDate: null}
            dateFormat={formatoDataHora}
            isClearable={true}  
            showTimeSelect={true}
            timeCaption={t('TIME_CAPTION')}
          /> 
        </>
      )}

      {/* ##############################  isNumber ############################## */}

      {(isNumber && !isRange) && (
        <>
          <CurrencyInput
            className={'form-control'}
            allowNegative={false}
            thousandSeparator={(user.locale.thousandSeparator)}
            decimalSeparator={(user.locale.decimalSeparator)}
            value={UtilService.formatNumberIdioma(props.value)}
            onChange={(val: any) => { props.handleChangeMoney(val, props.index, props.data); }}
          />          
          <Form.Label>
            {props.label}
          </Form.Label>
        </>
      )}


      {(isNumber && isRange) && (
        <>
          <div className="row">
            <div className="col-md-6 form-floating">
              <CurrencyInput
                className={'form-control'}
                value={valorFloatInicio}
                onChange={(val) => {
                  setValorFloatInicio(val);
                }}
                onBlur={(val) => {
                  let retorno = UtilService.compareValues(valorFloatInicio, valorFloatFim);
                  if (!retorno) {
                    setValorFloatInicio(0);
                  }

                  props.handleChangeMoneyRange(valorFloatInicio, valorFloatFim, props.index, props.data);
                }}
                allowNegative={false}
                thousandSeparator={(user.locale.thousandSeparator)}
                decimalSeparator={(user.locale.decimalSeparator)}
              />
              <Form.Label style={{ paddingLeft: 25 }}>
                {props.labelRangeMin}
              </Form.Label>
            </div>

            <div className="col-md-6 form-floating">
              <CurrencyInput
                className={'form-control'}
                value={valorFloatFim}
                onChange={(val) => {
                  setValorFloatFim(val);
                }}
                onBlur={(val) => {
                  let retorno = UtilService.compareValues(valorFloatInicio, valorFloatFim);
                  if (!retorno) {
                    setValorFloatInicio(0);
                  }
                  props.handleChangeMoneyRange(valorFloatInicio, valorFloatFim, props.index, props.data);
                }}
                allowNegative={false}
                thousandSeparator={(user.locale.thousandSeparator)}
                decimalSeparator={(user.locale.decimalSeparator)}
              />
              <Form.Label style={{ paddingLeft: 25 }}>
                {props.labelRangeMax}
              </Form.Label>
            </div>

          </div>
        </>
      )}

      {/* ##############################  isInteger ############################## */}

      {(isInteger && !isRange) && (
        <>
          <Form.Control
            name={props.name}
            id={props.id}
            value={UtilService.onlyNumber(valorInt)}
            placeholder={props.placeholder}
            disabled={props.disabled}
            type='text'
            onChange={(val) => {
              let value = val.target.value;
              setValorInt(UtilService.onlyNumber(value));
              props.handleChangeNumber(UtilService.onlyNumber(value), props.index, props.data)
            }}
            onBlur={(val) => {
              let value = val.target.value;
              setValorInt(UtilService.onlyNumber(value));
              props.handleChangeNumber(UtilService.onlyNumber(value), props.index, props.data)
            }}
          />
          <Form.Label>
            {props.label}
          </Form.Label>
        </>
      )}

      {(isInteger && isRange) && (
        <>
          <div className="row">
            <div className="col-md-6 form-floating">
              <Form.Control
                name={'valorInicio'}
                id={'valorInicio'}
                value={valorInicio}
                placeholder={props.placeholder}
                disabled={props.disabled}
                type='text'
                onChange={(val) => {
                  let value = val.target.value;
                  setValorInicio(UtilService.onlyNumber(value));
                  props.handleChangeNumberRange(valorInicio, valorFim, props.index, props.data)
                }}
                onBlur={(val) => {
                  let value = val.target.value;
                  setValorInicio(UtilService.onlyNumber(value));
                  props.handleChangeNumberRange(valorInicio, valorFim, props.index, props.data)
                }}
              />
              <Form.Label style={{ paddingLeft: 25 }}>
                {props.labelRangeMin}
              </Form.Label>
            </div>

            <div className="col-md-6 form-floating">
              <Form.Control
                name={'valorFim'}
                id={'valorFim'}
                value={valorFim}
                placeholder={props.placeholder}
                disabled={props.disabled}
                type='text'
                onChange={(val) => {
                  let value = val.target.value;
                  setValorFim(UtilService.onlyNumber(value));
                  props.handleChangeNumberRange(valorInicio, valorFim, props.index, props.data)
                }}
                onBlur={(val) => {
                  let value = val.target.value;
                  setValorFim(UtilService.onlyNumber(value));
                  props.handleChangeNumberRange(valorInicio, valorFim, props.index, props.data)
                }}
              />
              <Form.Label style={{ paddingLeft: 25 }}>
                {props.labelRangeMax}
              </Form.Label>
            </div>
          </div>
        </>
      )}


      {/* ##############################  isInteger ############################## */}

      {/* ##############################  isBoolean ############################## */}

      {isBoolean && (
        <>
          <Form.Select
            id={props.id}
            name={props.name}
            disabled={props.disabled}
            onChange={(val) => {
              props.onChange(val)
            }}
            value={props.value}
            aria-label={"ddd"}
          >
            <option value="">{t("CONFIG.VALUEDATATYPE")}</option>
            {_.map(ValueBooleanList, (i) => {
              return <option key={i.id} value={i.id}>{i.name}</option>
            })}
          </Form.Select>
          <Form.Label>
            {props.label}
          </Form.Label>
        </>
      )}

      {/* ##############################  ??????? ############################## */}

    </>
  );
};
''